import { type FC } from 'react'

import checkCircle from '@core/assets/v2/icons/checks/solid/Icon-Check-Circle-Solid.svg'
import checkLarge from '@core/assets/v2/icons/checks/solid/Icon-Check-Large-Solid.svg'
import checkSmall from '@core/assets/v2/icons/checks/solid/Icon-Check-Small-Solid.svg'
import checkSquare from '@core/assets/v2/icons/checks/solid/Icon-Check-Square-Solid.svg'
import verified from '@core/assets/v2/icons/checks/solid/Icon-Verified-Solid.svg'

import { createIcon } from './createIcon'
import type { CheckIconName, IconProps } from './types'

export const IconCheckCircle = createIcon(checkCircle, 'CheckCircle')
export const IconCheckLarge = createIcon(checkLarge, 'CheckLarge')
export const IconCheckSmall = createIcon(checkSmall, 'CheckSmall')
export const IconCheckSquare = createIcon(checkSquare, 'CheckSquare')
export const IconVerified = createIcon(verified, 'Verified')

export const checkIcons: Record<CheckIconName, FC<IconProps>> = {
    CheckCircle: IconCheckCircle,
    CheckLarge: IconCheckLarge,
    CheckSmall: IconCheckSmall,
    CheckSquare: IconCheckSquare,
    Verified: IconVerified,
}
